/* eslint-disable react/jsx-boolean-value */
import { useCallback } from "react";
import classnames from "classnames";
import "./pagination.scss";
import ArrowLeftOutlinedIcon from "@mui/icons-material/ArrowLeftOutlined";
import { Button } from "@mui/material";
import ArrowRightOutlinedIcon from "@mui/icons-material/ArrowRightOutlined";
interface PaginationProps {
  page: number;
  totalPage: number;
  setPage: (page: number) => void;
  inSharing?: boolean;
}
const Pagination = (props: PaginationProps) => {
  const { page, totalPage, setPage, inSharing } = props;
  const pageIndication = `${page + 1}/${totalPage}`;
  const toPreviousPage = useCallback(() => {
    if (page > 0) {
      setPage(page - 1);
    }
  }, [page, setPage]);
  const toNextPage = useCallback(() => {
    if (page < totalPage - 1) {
      setPage(page + 1);
    }
  }, [page, totalPage, setPage]);
  return (
    <div className={classnames("pagination", { "in-sharing": inSharing })}>
      <Button
        key="left"
        className="previous-page-button"
        endIcon={<ArrowLeftOutlinedIcon />}
        onClick={toPreviousPage}
      >
        {pageIndication}
      </Button>
      <Button
        key="right"
        className="next-page-button"
        endIcon={<ArrowRightOutlinedIcon />}
        onClick={toNextPage}
      >
        {pageIndication}
      </Button>
    </div>
  );
};

export default Pagination;
